export enum ProductsOverviewsVariations {
  withTwoColumns = 'productsOverviewsWithTwoColumns',
}
